/**
 * MosaicContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '@shared/components/utils/hoc/withAnimation';

/**
 * Props for the mosaic container.
 */
interface Props {
  displacePosition?: boolean;
  displaceMenu?: boolean;
}

/**
 * Styled mosaic container.
 */
const MosaicContainer = styled.div<Props>`
  position: relative;
  top: ${(props) => (props.displacePosition ? 602 : 144) * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
`;

export default withAnimation(MosaicContainer);
